import React from "react";
import { Form, Button, Dropdown } from "semantic-ui-react";
import { useFormik } from "formik";
import { BasicModal } from "../../../Shared";
import { useLanguage } from "../../../../contexts";
import { determineWasteUnits } from "../../../../utils/dataAndFormulas/wasteForms";
import "./UnitsForm.scss";

export function UnitsForm(props) {
  const { show, onClose, onSave, currentUnits, registeredFields } = props;
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  // Todos los campos de waste con sus 29 campos
  const allWasteFields = [
    { key: "paper_and_cardboard", label: t("paper_and_cardboard") },
    { key: "plastic", label: t("plastic") },
    { key: "fabric_scraps", label: t("fabric_scraps") },
    { key: "metal_clean", label: t("metal_clean") },
    { key: "wood", label: t("wood") },
    { key: "food_waste", label: t("food_waste") },
    { key: "general_trash", label: t("general_trash") },
    { key: "glass", label: t("glass") },
    { key: "leather", label: t("leather") },
    { key: "foam_eva", label: t("foam_eva") },
    { key: "empty_cans_or_containers", label: t("empty_cans_or_containers") },
    { key: "rubber", label: t("rubber") },
    { key: "other_non_hazardous_waste", label: t("other_non_hazardous_waste") },
    { key: "batteries", label: t("batteries") },
    { key: "electronics", label: t("electronics") },
    {
      key: "drums_or_containers_with_product_remains",
      label: t("drums_or_containers_with_product_remains"),
    },
    { key: "hospital_waste", label: t("hospital_waste") },
    { key: "fluorescent_tubes", label: t("fluorescent_tubes") },
    { key: "cooking_oil", label: t("cooking_oil") },
    { key: "maintenance_oil", label: t("maintenance_oil") },
    { key: "lubricants", label: t("lubricants") },
    { key: "paint_waste", label: t("paint_waste") },
    { key: "coal_ashes", label: t("coal_ashes") },
    { key: "rubber_hazardous", label: t("rubber_hazardous") },
    { key: "chemicals", label: t("chemicals") },
    { key: "contaminated_materials", label: t("contaminated_materials") },
    { key: "ink_cartridges", label: t("ink_cartridges") },
    { key: "medical_waste", label: t("medical_waste") },
    { key: "other_hazardous_waste", label: t("other_hazardous_waste") },
  ];

  // Si hay campos registrados en el Form, usar solo los activos; si no, usar todos
  const wasteFields =
    registeredFields && registeredFields.length > 0
      ? registeredFields
          .filter((field) => field.active !== false)
          .map((field) => ({
            key: field.name,
            label: t(field.name),
          }))
      : allWasteFields;

  const formik = useFormik({
    initialValues: wasteFields.reduce((acc, field) => {
      // Si ya existe una unidad guardada, usarla
      if (currentUnits?.[field.key]) {
        acc[field.key] = currentUnits[field.key];
      } else {
        // Si no hay unidad guardada, obtener las opciones disponibles
        const availableUnits = determineWasteUnits(field.key);
        // Si solo hay una opción, asignarla automáticamente
        if (availableUnits.length === 1) {
          acc[field.key] = availableUnits[0].value;
        } else {
          acc[field.key] = "";
        }
      }
      return acc;
    }, {}),
    enableReinitialize: true,
    onSubmit: (values) => {
      onSave(values);
      onClose();
    },
  });

  return (
    <BasicModal
      show={show}
      close={onClose}
      size="large"
      className="units-form-modal"
    >
      <Form onSubmit={formik.handleSubmit} className="units-form-modal">
        <div className="units-form-modal__title">{t("configure_units")}</div>
        <div className="units-grid">
          {wasteFields.map((field) => (
            <div key={field.key} className="unit-row">
              <span className="unit-label">{field.label}</span>
              <Dropdown
                placeholder={t("select_unit")}
                fluid
                selection
                search
                clearable
                options={determineWasteUnits(field.key)}
                value={formik.values[field.key]}
                onChange={(_, data) =>
                  formik.setFieldValue(field.key, data.value)
                }
              />
            </div>
          ))}
        </div>

        <div style={{ marginTop: "20px", display: "flex", justifyContent: "center", gap: "8px" }}>
          <Button primary onClick={formik.handleSubmit}>
            {t("save")}
          </Button>
          <Button onClick={onClose} className="units-btn-cancel">
            {t("cancel")}
          </Button>
        </div>
      </Form>
    </BasicModal>
  );
}
